var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"review-my"},[_c('list',{attrs:{"apiList":_vm.apiList,"fs":_vm.reviewFields,"showAction":false,"api":"reviews","title":"Reviews"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }